import { Routes } from "@angular/router";
import { PropertyLandingComponent } from "@app/pages/properties/landing/propertylanding.component";
import { HoaDetailsComponent } from "@app/pages/properties/hoadetails/hoadetails.component";
import { PropertyDetailsComponent } from "@app/pages/properties/propertydetails/propertydetails.component";
import { CreatePropertyGroupComponent } from "@app/pages/properties/propertygroup/createpropertygroup.component";
import { PropertyGroupDetailsComponent } from "@app/pages/properties/propertygroup/propertygroupdetails.component";
import { AddPropertyComponent } from "@app/pages/properties/addProperty/addProperty.component";
import {
    PropertyMultiRelationshipsComponent
} from "@app/pages/properties/propertygroup/propertyMultiRelationships.component";
import { PaymentCancelComponent } from "@app/pages/payment/paymentcancel/paymentCancel.component";
import { PaymentHistoryComponent } from "@app/pages/properties/paymentHistory/paymentHistory.component";
import { PaymentComponent } from "@app/pages/payment/payment.component";
import { PaymentConfirmationComponent } from "@app/pages/payment/paymentconfirmation/paymentconfirmation.component";
import { PaymentSuccessComponent } from "@app/pages/payment/successpaymentconfirmation/paymentsuccess.component";
import { ScheduleConfirmationComponent } from "@app/pages/payment/scheduleConfirmation/scheduleconfirmation.component";
import { PaymentEditComponent } from "@app/pages/payment/paymentEdit/paymentEdit.component";
import { ScheduleEditComponent } from "@app/pages/payment/scheduleEdit/scheduleEdit.component";
import { ScheduleEditDayComponent } from "@app/pages/payment/scheduleEdit/scheduleEditDay.component";
import { ScheduleViewComponent } from "@app/pages/payment/scheduleView/scheduleView.component";
import { OneTimeEditComponent } from "@app/pages/payment/scheduleEdit/one-time-edit.component";
import { WalletLandingComponent } from "@app/pages/wallet/landing/walletlanding.component";
import { CreditCardAddComponent } from "@app/pages/wallet/cardadd/creditCardAdd.component";
import { CheckingAccountAddComponent } from "@app/pages/wallet/checkadd/checkingAccountAdd.component";
import { CheckingAccountDetailsComponent } from "@app/pages/wallet/editcheckdetails/checkingAccountDetails.component";
import {
    ViewCheckingAccountDetailsComponent
} from "@app/pages/wallet/viewcheckdetails/viewCheckingAccountDetails.component";
import { EditCardDetailsComponent } from "@app/pages/wallet/editcarddetails/cardDetails.component";
import { ViewCardDetailsComponent } from "@app/pages/wallet/viewcarddetails/viewCardDetails.component";
import { ContactComponent } from "@app/pages/more/contact/contact.component";
import { MoreLandingComponent } from "@app/pages/more/landing/morelanding.component";
import { AccountComponent } from "@app/pages/more/account/account.component";
import { AlertsComponent } from "@app/pages/more/alerts/alerts.component";
import { TermsAndConditionsComponent } from "@app/pages/more/termsandconditions/termsAndConditions.component";
import { FAQComponent } from "@app/pages/more/faq/faq.component";
import { MooBankComponent } from "@app/pages/more/moobank/moobank.component";
import { pageTitle } from "@app/GuestRoutes";
import {
    FuturePaymentConfirmationComponent
} from "@app/pages/payment/future-payment-confirmation/future-payment-confirmation.component";

export const RegisteredRoutes: Routes = [

    { path: 'properties/:pmcCouponId/hoadetails', component: HoaDetailsComponent,
        title: pageTitle("Registered", "Properties", "HOA Details"),
        data: { section: 'properties.hoadetails' } },

    { path: 'properties/:propertyId/details', component: PropertyDetailsComponent,
        title: pageTitle("Registered", "Properties", "Property Details"),
        data: { section: 'properties.details' } },

    { path: 'properties/propertyGroup/create/:propertyId', component: CreatePropertyGroupComponent,
        title: pageTitle("Registered", "Properties", "Create Property Group"),
        data: { section: 'properties.createPropertyGroup' } },

    { path: 'properties/propertyGroup/:propertyGroupId', component: PropertyGroupDetailsComponent,
        title: pageTitle("Registered", "Properties", "Property Group Details"),
        data: { section: 'properties.propertyGroup' } },

    { path: 'properties/propertyGroup/multiRelationShips/:propertyId', component: PropertyMultiRelationshipsComponent,
        title: pageTitle("Registered", "Properties", "Property Group Relationships"),
        data: { section: 'properties.multiRelationShips' } },

    { path: 'properties', component: PropertyLandingComponent,
        title: pageTitle("Registered", "Properties"),
        data: { section: 'properties.landing' } },

    { path: 'properties/add', component: AddPropertyComponent,
        title: pageTitle("Registered", "Properties", "Add Property"),
        data: { section: 'properties.add' } },

    { path: 'properties/paymentCancel', component: PaymentCancelComponent,
        title: pageTitle("Registered", "Payment", "Cancel Payment"),
        data: { section: 'paymentCancel', hideFooter: true, isGuest: false } },

    { path: 'properties/:propertyId/paymentHistory', component: PaymentHistoryComponent,
        title: pageTitle("Registered", "Properties", "Property Payment History"),
        data: { section: 'properties.paymentHistory' } },

    { path: 'properties/:propertyId/payment', component: PaymentComponent,
        title: pageTitle("Registered", "Properties", "Property Payment"),
        data: { section: 'properties.payment' } },

    { path: 'properties/:propertyId/payment/:type', component: PaymentComponent,
        title: pageTitle("Registered", "Properties", "Payment Method"),
        data: { section: 'properties.payment' } },

    { path: 'properties/:propertyId/paymentConfirmation', component: PaymentConfirmationComponent,
        title: pageTitle("Registered", "Properties", "Confirm Payment"),
        data: { section: 'properties.paymentConfirmation' } },

    { path: 'properties/:propertyId/futurePaymentConfirmation', component: FuturePaymentConfirmationComponent,
        title: pageTitle("Registered", "Properties", "Confirm Future Payment"),
        data: { section: 'properties.futurePaymentConfirmation' } },

    { path: 'properties/:propertyId/paymentSuccess', component: PaymentSuccessComponent,
        title: pageTitle("Registered", "Properties", "Payment Accepted"),
        data: { section: 'properties.paymentSuccess' } },

    { path: 'properties/:propertyId/scheduleConfirmation', component: ScheduleConfirmationComponent,
        title: pageTitle("Registered", "Properties", "Confirm Payment Schedule"),
        data: { section: 'properties.scheduleConfirmation' } },

    { path: 'properties/paymentEdit/:scheduleId/:paymentId', component: PaymentEditComponent,
        title: pageTitle("Registered", "Properties", "Edit Payment"),
        data: { section: 'properties.paymentEdit' } },

    { path: 'properties/scheduleEdit/:scheduleId', component: ScheduleEditComponent,
        title: pageTitle("Registered", "Properties", "Edit Payment Schedule"),
        data: { section: 'properties.scheduleEdit' } },

    { path: 'properties/oneTimeEdit/:scheduleId', component: OneTimeEditComponent,
        title: pageTitle("Registered", "Properties", "Edit One-Time Payment"),
        data: { section: 'properties.oneTimeEdit' } },

    { path: 'properties/scheduleEditDay/:scheduleId', component: ScheduleEditDayComponent,
        title: pageTitle("Registered", "Properties", "Edit Payment Schedule Day"),
        data: { section: 'properties.scheduleEditDay' } },

    { path: 'properties/scheduleView/:scheduleId', component: ScheduleViewComponent,
        title: pageTitle("Registered", "Properties", "Schedule Details"),
        data: { section: 'properties.scheduleView' } },

    { path: 'wallet', component: WalletLandingComponent,
        title: pageTitle("Registered", "Wallet"),
        data: { section: 'wallet.landing' } },

    { path: 'wallet/creditcardadd', component: CreditCardAddComponent,
        title: pageTitle("Registered", "Wallet", "Add Card Payment Method"),
        data: { section: 'wallet.creditcardadd' } },

    { path: 'wallet/checkadd', component: CheckingAccountAddComponent,
        title: pageTitle("Registered", "Wallet", "Add Check Payment Method"),
        data: { section: 'wallet.checkadd' } },

    { path: 'wallet/editcheckdetails/:paymentMethodId', component: CheckingAccountDetailsComponent,
        title: pageTitle("Registered", "Wallet", "Edit Check Payment Method"),
        data: { section: 'wallet.editcheckdetails' } },

    { path: 'wallet/viewcheckdetails/:paymentMethodId', component: ViewCheckingAccountDetailsComponent,
        title:  pageTitle("Registered", "Wallet", "View Check Payment Method"),
        data: { section: 'wallet.checkdetails' } },

    { path: 'wallet/editcarddetails/:paymentMethodId', component: EditCardDetailsComponent,
        title: pageTitle("Registered", "Wallet", "Edit Card Payment Method"),
        data: { section: 'wallet.editcarddetails' } },

    { path: 'wallet/viewcarddetails/:paymentMethodId', component: ViewCardDetailsComponent,
        title: pageTitle("Registered", "Wallet", "View Card Payment Method"),
        data: { section: 'wallet.carddetails' } },

    { path: 'contact', component: ContactComponent,
        title: pageTitle("Registered", "Contact"),
        data: { section: 'contact.landing' } },

    { path: 'more', component: MoreLandingComponent,
        title: pageTitle("Registered", "More"),
        data: { section: 'more.landing' } },

    { path: 'more/myaccount', component: AccountComponent,
        title: pageTitle("Registered", "More", "Account"),
        data: { section: 'more.account' } },

    { path: 'alerts', component: AlertsComponent,
        title: pageTitle("Registered", "More", "Alerts"),
        data: { section: 'more.alerts' } },

    { path: 'more/termsAndConditions', component: TermsAndConditionsComponent,
        title: pageTitle("Registered", "More", "Terms and Conditions"),
        data: { section: 'more.termsAndConditions' } },

    { path: 'more/FAQ', component: FAQComponent,
        title: pageTitle("Registered", "More", "Frequently Asked Questions"),
        data: { section: 'more.faq' } },

    { path: 'more/about', component: MooBankComponent,
        title: pageTitle("Registered", "More", "About First Citizens Bank"),
        data: { section: 'more.about' } },
]
